import { useState } from "react";
import { Soup } from "lucide-react";
import type { Recipe } from "@ainkauf/core";

/**
 * Das Titelbild eines Rezepts, oder ein Topf.
 *
 * Fester Kasten, damit beim Nachladen nichts springt. Ein kaputtes oder
 * abgelaufenes Bild (die Adresse der Spaisekammer gilt sieben Tage) darf
 * keinen leeren Rahmen und keinen Alternativtext hinterlassen: Dann steht
 * wieder der Topf da, als wäre nie ein Bild vorgesehen gewesen.
 */
export function RecipeCover({ recipe, size = 44 }: { recipe: Pick<Recipe, "cover_url" | "name">; size?: number }) {
  const [kaputt, setKaputt] = useState(false);
  const zeigeBild = recipe.cover_url !== null && recipe.cover_url.length > 0 && !kaputt;

  return (
    <span
      aria-hidden
      data-testid="recipe-cover"
      data-image={zeigeBild ? "ja" : "nein"}
      className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[var(--radius-lg)] bg-paper-2 text-ink-3"
      style={{ width: size, height: size }}
    >
      {zeigeBild ? (
        <img
          src={recipe.cover_url ?? ""}
          alt=""
          loading="lazy"
          decoding="async"
          width={size}
          height={size}
          onError={() => {
            setKaputt(true);
          }}
          className="size-full object-cover"
        />
      ) : (
        <Soup size={Math.round(size * 0.5)} strokeWidth={1.75} />
      )}
    </span>
  );
}
